import { Product, ProductVariant } from '@/queries/types/graphql';

import getProductFinish from './getProductFinish';

/**
 * Find the variant for a finish + size selection. Falls back to the finish's
 * first variant (the unsized "size pending" placeholder) when the size doesn't
 * match, mirroring findSku's selection semantics.
 */
export const findVariant = (
  products: Product[],
  finish: string,
  size?: string,
): ProductVariant | undefined => {
  const selectedProduct = products.find(
    (product) => getProductFinish(product) === finish,
  );

  if (!selectedProduct) {
    return undefined;
  }

  return (
    selectedProduct.variants?.find((variant) =>
      variant?.selectedOptions.find(
        (opt) => opt?.name === 'Size' && opt.value === size,
      ),
    ) ??
    selectedProduct.variants?.[0] ??
    undefined
  );
};

const findSku = (
  products: Product[],
  finish: string,
  size?: string,
): string | undefined => {
  return findVariant(products, finish, size)?.skuCode;
};

export default findSku;
